import { useTranslation } from "@opendash/i18n";
import { Icon } from "@opendash/icons";
import {
  Button,
  Card,
  Checkbox,
  CheckboxChangeEvent,
  Divider,
  Flex,
  Typography,
} from "antd";
import { observer } from "mobx-react-lite";
import React from "react";
import { Async } from "../../../../_shared";
import { Message } from "../../../../js/parsegenerated";
import { useTodoMessage } from "../hooks/useTodoMessage";

type Props = {
  message: Message;
  onUpdate?: () => Async<void>;
};

export const TodoListItem = observer((props: Props) => {
  const t = useTranslation();
  const { deleteTodo, toggleTodo, loading } = useTodoMessage(props.message);

  async function onToggleTodo(e: CheckboxChangeEvent) {
    await toggleTodo(e.target.checked);
    props.onUpdate?.();
  }

  async function onDeleteTodo() {
    await deleteTodo();
    props.onUpdate();
  }

  return (
    <Card size="small">
      <Flex gap="small" align="center">
        <Checkbox
          checked={props.message.data?.todoCompleted}
          onChange={onToggleTodo}
          disabled={loading}
        />
        <Typography.Text strong>
          {t(props.message.get("title"))}
        </Typography.Text>
        <Divider type="vertical" />
        <Typography.Text>{props.message.get("content")}</Typography.Text>
        <Button
          type="text"
          onClick={onDeleteTodo}
          danger
          style={{ marginLeft: "auto" }}
        >
          <Icon icon="fa:trash" />
        </Button>
      </Flex>
    </Card>
  );
});
